var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox checkbox-switchery",class:{ 'disabled': _vm.disabled }},[_c('label',{staticClass:"switch",attrs:{"for":_vm.id},on:{"click":_vm.toggle}},[_c('input',{class:_vm.classes,attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked}}),_vm._v(" "),_c('span',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }